import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { FaExpand, 
// FaChevronLeft,
// FaChevronRight,
FaMinusCircle, FaPlusCircle, FaWindowMinimize, } from 'react-icons/fa';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { getPatientPDFUrl } from '~/helpers';
import { GrRotateRight } from 'react-icons/all';
import Draggable from 'react-draggable';
export const PDFViewer = (props) => {
    const pagesArray = [];
    const { className, file } = props;
    const [numPages, setNumPages] = useState(0);
    // const [pageNumber, setPageNumber] = useState(1);
    const [pageOrientation, setPageOrientation] = useState('rotate-landscape-zero');
    const [numPagesArray, setNumPagesArray] = useState(pagesArray);
    const [scale, setScale] = useState(1.5);
    const [pdfExpanded, setPdfExpanded] = useState(false);
    // Set initial scale based on screen size
    useEffect(() => {
        const updateScale = () => {
            const screenWidth = window.innerWidth;
            console.log('Screen Width');
            console.log(screenWidth);
            console.log('Screen Width');
            if (screenWidth < 1200)
                setScale(0.75);
            else if (screenWidth < 1300)
                setScale(1);
            else if (screenWidth < 1400)
                setScale(1.25);
            else
                setScale(1.5);
        };
        updateScale();
        window.addEventListener("resize", updateScale);
        return () => window.removeEventListener("resize", updateScale);
    }, []);
    function onDocumentLoadSuccess(data) {
        setNumPages(data.numPages);
        for (let i = 1; i < data.numPages + 1; i++) {
            pagesArray.push(i);
        }
        setNumPagesArray(pagesArray);
        console.log(numPages);
    }
    // const previousPage = () => {
    //   setPageNumber(pageNumber - 1);
    // };
    // const nextPage = () => {
    //   setPageNumber(pageNumber + 1);
    // };
    const changeOrientation = () => {
        if (pageOrientation === 'rotate-landscape-zero') {
            setPageOrientation('rotate-landscape-counter');
        }
        else {
            setPageOrientation('rotate-landscape-zero');
        }
    };
    const reduceSize = () => {
        setScale((prevValue) => (prevValue > 0.25 ? prevValue - 0.25 : prevValue));
    };
    const increaseSize = () => {
        setScale((prevValue) => prevValue + 0.25);
    };
    const openPdfInNewTab = () => {
        setPdfExpanded(!pdfExpanded);
        const reportPane = document.querySelectorAll('.patient-report-pane');
        if (reportPane[0].classList.contains('hidden')) {
            reportPane[0].classList.remove('hidden');
        }
        else {
            reportPane[0].classList.add('hidden');
        }
    };
    return (React.createElement("div", { className: clsx('w-full h-full grid group min-h-0 min-w-0', className) },
        React.createElement("div", { className: "grid place-items-center col-start-1 row-start-1 overflow-auto min-h-0 min-w-0 h-full w-full" },
            React.createElement(Document, { file: getPatientPDFUrl(file), onLoadSuccess: onDocumentLoadSuccess, loading: React.createElement("div", { className: "text-white text-sm" }, "Loading PDF...") }, numPagesArray.map(page => (React.createElement(Page, { pageNumber: page, scale: scale, className: pageOrientation }))))),
        React.createElement(Draggable, null,
            React.createElement("div", { className: "relative bg-gray-50 z-10 place-self-end mb-10 col-start-1 row-start-1 justify-self-center px-3 py-2 transition-opacity duration-200 rounded-2xl shadow-lg uppercase text-sm opacity-0 group-hover:opacity-100 flex items-center" },
                React.createElement("button", { type: "button", onClick: reduceSize, "aria-label": "Reduce size", className: "w-6 h-6 ml-2 flex items-center justify-center transition-transform duration-200 ease-in-out transform hover:scale-125" },
                    React.createElement(FaMinusCircle, null)),
                React.createElement("button", { type: "button", onClick: increaseSize, "aria-label": "Enlarge", className: "w-6 h-6 ml-2 flex items-center justify-center transition-transform duration-200 ease-in-out transform hover:scale-125" },
                    React.createElement(FaPlusCircle, null)),
                React.createElement("span", { className: "mx-4 opacity-30", "aria-hidden": "true" }, "|"),
                React.createElement("button", { type: "button", onClick: changeOrientation, "aria-label": "Rotate", className: "w-6 h-6 ml-2 flex items-center justify-center transition-transform duration-200 ease-in-out transform hover:scale-125" },
                    React.createElement(GrRotateRight, null)),
                React.createElement("button", { type: "button", "aria-label": "Rotate", onClick: openPdfInNewTab, className: "w-6 h-6 ml-2 flex items-center justify-center transition-transform duration-200 ease-in-out transform hover:scale-125" }, pdfExpanded ? React.createElement(FaWindowMinimize, null) : React.createElement(FaExpand, null))))));
};
